import { render, staticRenderFns } from "./Treeselect8.vue?vue&type=template&id=6c3b7618"
import script from "./Treeselect8.vue?vue&type=script&lang=js"
export * from "./Treeselect8.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports